import {createContext} from 'react';

export interface LocaleCDWProps {
  [key: string]: CDWProps;
}

export interface LocaleCDWContent {
  [key: string]: {cdw: CDWContent};
}

export interface CDWContent {
  CDW_ID: string;
  markdown: string;
}

export interface CDWItem {
  [key: string]: CDWContent;
}

export interface CDWProps {
  CDW: CDWItem;
}

export const CDWPropsContext = createContext({
  CDW: {},
} as CDWProps);
